import { useMemo } from 'react';
import { ExtendedTicketEvent } from './timeline-utils';
import { EventItem } from './EventItem';
import { useCurrentUser, useUserMap } from '@/features/users/users.hooks';
import { AddAttachmentPayload } from '@certhon/models';
import { HiddenEventsToggle } from '@/components/Timeline';

interface HiddenEventsGroupProps {
  events: ExtendedTicketEvent[];
  /** Timestamp of the entry rendered before this group (for delta mode). */
  previousTimestamp?: Date;
  onEdit: (eventId: string) => void;
  editingEventId: string | null;
  onUpdateMessage: (eventId: string, message: string) => void;
  onCancelEdit: () => void;
  onDelete: (eventId: string) => void;
  onDownload: (attachment: AddAttachmentPayload) => void;
  onOpenInLightbox: (attachment: AddAttachmentPayload) => void;
}

export function HiddenEventsGroup({
  events,
  previousTimestamp,
  onEdit,
  editingEventId,
  onUpdateMessage,
  onCancelEdit,
  onDelete,
  onDownload,
  onOpenInLightbox,
}: HiddenEventsGroupProps) {
  const user = useCurrentUser()!;
  const userMap = useUserMap();

  const userIds = useMemo(() => events.map((event) => event.user_id), [events]);

  return (
    <HiddenEventsToggle count={events.length} userIds={userIds}>
      {events.map((event, index) => {
        const prevTs =
          index > 0 ? events[index - 1].created : previousTimestamp;
        return (
          <EventItem
            key={event.id}
            event={event}
            isGroupStart={event.isUserGroupStart ?? false}
            isLastEvent={false}
            previousTimestamp={prevTs}
            user={userMap.get(event.user_id)!}
            currentUserId={user.recnum}
            onEdit={() => onEdit(event.id)}
            isEditing={editingEventId === event.id}
            onUpdateMessage={onUpdateMessage}
            onCancelEdit={onCancelEdit}
            onDelete={() => onDelete(event.id)}
            onDownload={onDownload}
            onOpenInLightbox={onOpenInLightbox}
          />
        );
      })}
    </HiddenEventsToggle>
  );
}
